import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: "30px", // Doubles the default border radius
    padding: theme.spacing(1, 3), // Adds padding for a balanced look
    marginRight: theme.spacing(2), // Spacing between buttons
    textTransform: "none", // Keeps button text in sentence case
    backgroundColor: "#F0CD7F",
    color: "#1C1C1C",
    fontWeight: "400",
    "&:hover": {
    backgroundColor: "#E0B86F", // Change background color on hover
    color: "#000000", // Change text color on hover
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
    '&:focus': {
      boxShadow: 'none',
    },
    '&:active': {
      boxShadow: 'none',
    },
  },
  }));